var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_421_1242)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_421_1242)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_421_1242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5366 22.5098C33.4342 22.3002 33.4342 22.0599 33.5366 21.8504L34.486 19.9082C35.0146 18.8267 34.5958 17.5378 33.5325 16.9737L31.6229 15.9604C31.4168 15.8511 31.2756 15.6566 31.2353 15.427L30.8618 13.2976C30.6538 12.112 29.5571 11.3154 28.3655 11.484L26.225 11.7867C25.994 11.8194 25.7655 11.7451 25.5979 11.583L24.0442 10.0799C23.1791 9.24293 21.8238 9.24288 20.9587 10.0799L19.4049 11.5831C19.2372 11.7453 19.0088 11.8194 18.7778 11.7869L16.6373 11.4841C15.4453 11.3154 14.349 12.1122 14.1411 13.2978L13.7676 15.427C13.7273 15.6567 13.586 15.8512 13.38 15.9605L11.4704 16.9738C10.4071 17.5379 9.98828 18.8269 10.5169 19.9083L11.4662 21.8505C11.5687 22.06 11.5687 22.3004 11.4662 22.5099L10.5168 24.4521C9.98823 25.5335 10.4071 26.8224 11.4703 27.3866L13.38 28.3998C13.586 28.5091 13.7273 28.7036 13.7676 28.9332L14.1411 31.0626C14.3304 32.1419 15.2558 32.8988 16.3195 32.8987C16.4242 32.8987 16.5305 32.8913 16.6373 32.8762L18.7779 32.5734C19.0087 32.5407 19.2373 32.6151 19.4049 32.7772L20.9587 34.2803C21.3913 34.6988 21.9463 34.908 22.5014 34.908C23.0564 34.9079 23.6117 34.6987 24.0442 34.2803L25.5979 32.7772C25.7656 32.6151 25.9941 32.541 26.225 32.5734L28.3655 32.8762C29.5577 33.0449 30.6538 32.2481 30.8618 31.0626L31.2353 28.9333C31.2756 28.7036 31.4169 28.5092 31.6229 28.3998L33.5325 27.3866C34.5958 26.8225 35.0146 25.5334 34.486 24.452L33.5366 22.5098ZM19.565 15.5733C21.0492 15.5733 22.2567 16.7808 22.2567 18.265C22.2567 19.7492 21.0492 20.9567 19.565 20.9567C18.0809 20.9567 16.8734 19.7492 16.8734 18.265C16.8734 16.7808 18.0809 15.5733 19.565 15.5733ZM18.1757 27.5439C18.0324 27.6872 17.8445 27.7589 17.6567 27.7589C17.4688 27.7589 17.2809 27.6873 17.1376 27.5439C16.8509 27.2572 16.8509 26.7924 17.1376 26.5057L26.8271 16.8163C27.1137 16.5296 27.5786 16.5296 27.8652 16.8163C28.1519 17.1029 28.1519 17.5677 27.8652 17.8544L18.1757 27.5439ZM25.4377 28.7869C23.9535 28.7869 22.746 27.5794 22.746 26.0952C22.746 24.6111 23.9535 23.4036 25.4377 23.4036C26.9219 23.4036 28.1294 24.6111 28.1294 26.0952C28.1294 27.5794 26.9219 28.7869 25.4377 28.7869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4374 24.8721C24.7628 24.8721 24.2139 25.4209 24.2139 26.0955C24.2139 26.7701 24.7627 27.319 25.4374 27.319C26.112 27.319 26.6608 26.7701 26.6608 26.0955C26.6608 25.4209 26.112 24.8721 25.4374 24.8721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5648 17.041C18.8901 17.041 18.3413 17.5899 18.3413 18.2645C18.3413 18.9391 18.8901 19.488 19.5648 19.488C20.2394 19.488 20.7883 18.9391 20.7883 18.2645C20.7882 17.5899 20.2394 17.041 19.5648 17.041Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_421_1242",
    x: 0,
    y: 0,
    width: 45,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8735 0 0 0 0 0.7125 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_421_1242"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_421_1242",
    x: -2.71143,
    y: 0.452148,
    width: 50.4258,
    height: 51.4561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.437444 0 0 0 0 0.120556 0 0 0 0 0.516667 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_421_1242"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_421_1242",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_421_1242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.01ff3de93bb73bd356bb7a399dd56279.svg";
export { ForwardRef as ReactComponent };